import React, { useContext, useEffect, useState, useMemo } from "react";
import "./PagosYReten.css";
import { STATES_COMPROBANTE } from "../../utils/states";
import {
  deleteAndGetPagosByNroCtaFromSoftland,
  getPagosNotAnnulledByNroCta,
} from "../../api/pagosYRetenciones";
import authContext from "../../context/authentication/authContex";
import proveedoresContext from "../../context/proveedores/proveedoresContext.js";
import SelectList from "../../components/SelectList/SelectList.js";
import PagosYRetencionesList from "../../components/pagosYretencionesList/PagosYRetencionesList";
import { getDateStringYYYYMMDD } from "../../utils/formatDate.js";

//Permisos
import { ACTUALIZAR_MOVIMIENTOS_PROVEEDOR } from "../../utils/permisos";
import Swal from "sweetalert2";

const PagosYReten = () => {
  //Context auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;

  const [filtros, setFiltros] = useState({
    fchdes: "1980-01-01",
    fchhas: getDateStringYYYYMMDD(),
  });
  const [pagos, setPagos] = useState([]);
  const [provider, setProvider] = useState({});
  const listHeight = useMemo(() => window.innerHeight - 280, []);

  /*     const handlerIniciarlizarFiltros = async () => {
            const state = STATES;
            await iniciarFiltros(state, usuario);
        } */

  /*     useEffect(()=>{
            setPagos((listTDoc != [] && listTDoc != null) ? listTDoc.filter((pago)  => ['OP','RG'].includes(pago.codFor)) : [])
        },[listTDoc]) */

  useEffect(() => {
    const fn = async () => {
      if (usuario.nroCta) {
        await obtenerPagosByNroCta();
      } else {
        await actualizarProveedores();
      }
    };
    fn();

    //handlerIniciarlizarFiltros();
  }, []);

  const handleChange = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const obtenerPagosByNroCta = async () => {
    try {
      const resp = await getPagosNotAnnulledByNroCta(usuario.nroCta);
      setPagos(resp.data.data);
    } catch (error) {
      console.error("Error al obtener pagos:", error);
    }
  };

  const handleChangeProveedor = async (value) => {
    const proveedorSeleccionado = proveedores.find(
      (p) =>
        `${p.nroCta}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (proveedorSeleccionado !== undefined) {
      setProvider(proveedorSeleccionado);
    }

    const resp = await getPagosNotAnnulledByNroCta(proveedorSeleccionado.nroCta);
    setPagos(resp.data.data);
  };

  const actualizarMovimientosSegunProveedor = async () => {
    Swal.fire({
      title: `Desea actualizar los movimientos del proveedor ${provider.nroCta} - ${provider.nombre}?`,
      text: "Se traeran los datos de Softland para sobreescribir los pagos y retenciones del proveedor seleccionado.",
      showCancelButton: true,
      confirmButtonText: "Actualizar",
      cancelButtonText: "No, cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteAndGetPagosByNroCtaFromSoftland(provider.nroCta)
          .then((response) => {
            if (!response.status) {
              throw new Error(response.msg);
            }
            return response;
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        setPagos(result.value.data.data.pagosCreated);
        Swal.fire(
          "Actualizado!",
          "La base de datos ha sido actualizada correctamente.",
          "success"
        );
      }
    });
  };

  return (
    <div className="ctaCorrienteDiv">
      <div
        style={{marginTop: "20px" }}
        className="asideFiltros"
      >
        {usuario.userType.some((item) =>
          ACTUALIZAR_MOVIMIENTOS_PROVEEDOR.includes(item.typeName)
        ) && (
          <SelectList
            text={"Proveedor:"}
            options={proveedores.map((p) => {
              return {
                value: `${p.nroCta}`,
                label: `${p.nroCta} - ${p.nombre}`,
              };
            })}
            handleChange={handleChangeProveedor}
            property={"Proveedor"}
            valueAux={{
              label:
                provider.nombre && provider.nroCta
                  ? `${provider.nroCta} - ${provider.nombre}`
                  : "Seleccione...",
              value: provider.nroCta || "",
            }}
            emptyInputs={[]}
            styles={{
              additionalStyleDivSelectList: {
                alignItems: "center",
                gap: "0.5rem",
              },
              fontStyleTitle: {
                fontSize: "1.5rem",
              },
            }}
          />
        )}

        <div className="inputGroup">
          <label>Fecha desde:</label>
          <input
            name="fchdes"
            type="date"
            defaultValue="1980-01-01"
            onChange={(e) => handleChange(e)}
          ></input>
        </div>
        <div className="inputGroup">
          <label>Fecha hasta:</label>
          <input
            name="fchhas"
            type="date"
            defaultValue={getDateStringYYYYMMDD()}
            onChange={(e) => handleChange(e)}
          ></input>
        </div>
      </div>
      <div className="resultadosDiv">
        {usuario.userType.some((item) =>
          ACTUALIZAR_MOVIMIENTOS_PROVEEDOR.includes(item.typeName)
        ) && (
          <button
            className={`actualizar-providers-btn ${
              !provider?.nroCta ? "disabled-btn" : ""
            }`}
            style={{
              marginLeft: "auto",
              marginTop: "-55px",
              display: "block",
            }}
            onClick={
              !provider?.nroCta ? null : actualizarMovimientosSegunProveedor
            }
          >
            Actualizar Movimientos
          </button>
        )}
        <PagosYRetencionesList
          pagosList={pagos}
          fchdes={filtros.fchdes}
          fchhas={filtros.fchhas}
        />
      </div>
    </div>
  );
};

export default PagosYReten;